import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="11.91" height="20.829" viewBox="0 0 11.91 20.829">
        <path id="chevron-right-regular" d="M2.49,34.751l-.931.931a.564.564,0,0,0,0,.8l8.5,8.52-8.5,8.52a.564.564,0,0,0,0,.8l.931.931a.564.564,0,0,0,.8,0l9.85-9.85a.564.564,0,0,0,0-.8l-9.85-9.85A.564.564,0,0,0,2.49,34.751Z" transform="translate(-1.394 -34.586)" fill="#676767"/>
    </svg>;
}
